import { render } from "./useDetail.vue?vue&type=template&id=1e9db632&scoped=true"
import script from "./useDetail.vue?vue&type=script&lang=js"
export * from "./useDetail.vue?vue&type=script&lang=js"

import "./useDetail.vue?vue&type=style&index=0&id=1e9db632&lang=less&scoped=true"
import "./useDetail.vue?vue&type=style&index=1&id=1e9db632&lang=css"

import exportComponent from "/workspace/cgsfront/cgs-office-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e9db632"]])

export default __exports__